import { render } from "./FooterLacen.vue?vue&type=template&id=050c140b&scoped=true"
const script = {}

import "./FooterLacen.vue?vue&type=style&index=0&id=050c140b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-050c140b"]])

export default __exports__